import React from 'react'

interface RankingInputProps {
  items: string[]
  ranking: { [key: string]: number }
  onChange: (ranking: { [key: string]: number }) => void
}

export default function RankingInput({ items, ranking, onChange }: RankingInputProps) {
  const handleRankChange = (item: string, rank: number) => {
    const newRanking = { ...ranking }

    // Remove the item from its current rank
    Object.keys(newRanking).forEach(key => {
      if (newRanking[key] === rank && key !== item) {
        delete newRanking[key]
      }
    })

    // If rank is 0, remove the item
    if (rank === 0) {
      delete newRanking[item]
    } else {
      newRanking[item] = rank
    }

    onChange(newRanking)
  }

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-600 mb-3">
        Rank 1-4 (1 = most important). Leave blank if not important.
      </p>
      {items.map(item => (
        <div key={item} className="flex items-center gap-4">
          <select
            value={ranking[item] || 0}
            onChange={(e) => handleRankChange(item, parseInt(e.target.value))}
            className="w-20 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-emerald-500 focus:border-emerald-500"
          >
            <option value={0}>-</option>
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={4}>4</option>
          </select>
          <span className="text-sm text-gray-700">{item}</span>
        </div>
      ))}
    </div>
  )
}
